module.exports = __webpack_public_path__ + "static/media/Fs3v6.99e86e97.mp3";